// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3_fyS","form":"style_form__3e7ZJ","header":"style_header__rI8qy","paragraph":"style_paragraph__31x8j","text":"style_text__342uh"};